export default {
    path: "/promotion",
    name: "promotion",
    redirect: "/promotion/coupon/list",
    component: () => import("@/layouts/base/index.vue"),
    meta: { title: "营销" },
    children: [
        {
            path: "/promotion",
            name: "promotionManage",
            meta: { title: "营销概览" },
            component: () => import("@/views/promotion/manage/List.vue")
        },
        {
            path: "",
            name: "promotionOverview",
            meta: { title: "营销管理" },
            redirect: "/promotion/coupon/list",
            children: [
                {
                    path: "coupon/list",
                    name: "couponManage",
                    meta: { title: "优惠券" },
                    component: () => import("@/views/promotion/coupon/List.vue")
                },
                {
                    path: "seckill/list",
                    name: "seckillManage",
                    meta: { title: "限时秒杀" },
                    component: () => import("@/views/promotion/seckill/List.vue")
                },
                {
                    path: "full-reduction/list",
                    name: "fullReductionManage",
                    meta: { title: "满减活动" },
                    component: () => import("@/views/promotion/productActivity/fullReduction/List.vue")
                },
                {
                    path: "reward-gift/list",
                    name: "rewardGiftManage",
                    meta: { title: "满赠活动" },
                    component: () => import("@/views/promotion/productActivity/rewardGift/List.vue")
                },
                {
                    path: "limitdiscount-gift/list",
                    name: "limitdiscountManage",
                    meta: { title: "限时折扣" },
                    component: () => import("@/views/promotion/productActivity/limitdiscount/List.vue")
                },
                {
                    path: "product-gift/list",
                    name: "productGiftManage",
                    meta: { title: "活动赠品" },
                    component: () => import("@/views/promotion/productGift/List.vue")
                },
                {
                    path: "points-exchange/list",
                    name: "pointsExchangeManage",
                    meta: { title: "积分商品" },
                    component: () => import("@/views/promotion/pointsExchange/List.vue")
                },
                {
                    path: "sign-in-setting/list",
                    name: "signInSettingManage",
                    meta: { title: "积分签到" },
                    component: () => import("@/views/promotion/signInSetting/List.vue")
                },
                {
                    path: "recharge-setting/list",
                    name: "rechargeSettingManage",
                    meta: { title: "余额充值" },
                    component: () => import("@/views/promotion/rechargeSetting/List.vue")
                },
                {
                    path: "live/list",
                    name: "liveManage",
                    meta: { title: "微信直播" },
                    component: () => import("@/views/promotion/live/List.vue")
                },
                {
                    path: "e-card/list",
                    name: "eCardManage",
                    meta: { title: "电子卡券" },
                    component: () => import("@/views/promotion/eCard/List.vue")
                }
            ]
        },
        {
            path: "",
            name: "promotionActOverview",
            meta: { title: "活动管理" },
            children: [
                {
                    path: "popup-ad/list",
                    name: "popupAdManage",
                    meta: { title: "活动弹窗" },
                    component: () => import("@/views/promotion/popupAd/list.vue")
                },
                {
                    path: "invite/list",
                    name: "inviteActManage",
                    meta: { title: "邀请免单" },
                    component: () => import("@/views/promotion/invite/List.vue")
                },
                {
                    path: "lottery/list",
                    name: "lotteryActManage",
                    meta: { title: "抽奖活动" },
                    component: () => import("@/views/promotion/lotteryActivity/List.vue")
                }
            ]
        }
    ]
};
